import {
  ReadonlyFeature as readonlyReducer,
  ReadonlyPayload,
  setReadonlyAction,
} from '@smartsheet-dataflow/formjs';
import { BridgeFormJSState } from '../../Types';
import { dummyDispatch } from '../ParamFromSchema';

export const reduceReadonly =
  (payload: ReadonlyPayload) => (state: BridgeFormJSState) =>
    readonlyReducer(state, setReadonlyAction(dummyDispatch)(payload));
